import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {DateTime} from 'luxon';

import {Hotel, Hotels, Properties} from './properties.interface';

export interface PropertiesState {
  readonly data: Properties;
  readonly error: boolean;
  readonly errorMsg: string;
  readonly loading: boolean;
  readonly lastQueryTime?: string;
}

export const initialState: PropertiesState = {
  data: [],
  error: false,
  errorMsg: '',
  loading: false,
  lastQueryTime: undefined,
};

const {actions: PropertiesActions, reducer: PropertiesReducer} = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    fetch(state) {
      state.loading = true;
    },
    fetchCachedSuccess(state) {
      state.loading = false;
      state.error = false;
      state.errorMsg = '';
    },
    fetchSuccess(state, action: PayloadAction<Properties>) {
      // A 200 that isn't JSON (login redirect, WAF/error page) reaches us as a
      // raw string, since axios silently skips parsing it. Treat it as an error
      // instead of persisting it as the properties list.
      if (!Array.isArray(action.payload)) {
        state.loading = false;
        state.data = [];
        state.lastQueryTime = undefined;
        state.error = true;
        state.errorMsg = 'No results';
        return;
      }

      state.loading = false;
      state.data = action.payload;
      state.lastQueryTime = DateTime.local().toISO();
      state.error = false;
      state.errorMsg = '';
    },
    fetchError(
      state,
      action: PayloadAction<{error: boolean; message: string}>
    ) {
      state.loading = false;
      state.error = action.payload.error;
      state.errorMsg = action.payload.message;
    },
  },
});

export {PropertiesActions};
export default PropertiesReducer;
